// ** React Imports
import { useState, useEffect, createContext } from 'react'

// ** Intl Provider Import
import { IntlProvider } from 'react-intl'

// ** React Router v5.2
import { useLocation, useHistory } from 'react-router-dom'

// ** Axios Import for Global Headers
import axios from 'axios'
import axiosClient from 'api/axiosClient'

// ** Core Language Data
import messagesEn from '../locales/en.json'
import messagesVn from '../locales/vn.json'

// ** Menu msg obj
const menuMessages = {
  en: { ...messagesEn },
  vn: { ...messagesVn }
}

let currentLangHeader = window.location.pathname.startsWith('/vi') ? 'vi' : 'en';

// 1. Axios Interceptor
axios.defaults.headers.common['Accept-Language'] = currentLangHeader;
axios.interceptors.request.use(config => {
  config.headers['Accept-Language'] = currentLangHeader;
  return config;
});
axiosClient.defaults.headers.common['Accept-Language'] = currentLangHeader;
axiosClient.interceptors.request.use(config => {
  config.headers['Accept-Language'] = currentLangHeader;
  return config;
});
// 2. Global Fetch Interceptor
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;
  config = config || {};

  if (config.headers instanceof Headers) {
    config.headers.set('Accept-Language', currentLangHeader);
  } else {
    config.headers = {
      ...config.headers,
      'Accept-Language': currentLangHeader
    };
  }
  return originalFetch(resource, config);
};

// ** Create Context
const Context = createContext()

const IntlProviderWrapper = ({ children }) => {
  const location = useLocation()
  const history = useHistory()

  // ** Init locale từ path
  const isVietnamese = location.pathname.startsWith('/vi')
  const defaultLocale = isVietnamese ? 'vn' : 'en'

  const [locale, setLocale] = useState(defaultLocale)
  const [messages, setMessages] = useState(menuMessages[defaultLocale])

  // ** Cập nhật lại biến toàn cục khi path đổi (mặc dù switchLanguage đang load lại trang)
  useEffect(() => {
    const lang = locale === 'vn' ? 'vi' : 'en'
    currentLangHeader = lang
    localStorage.setItem('lang', locale) // Store 'vn' or 'en' to match common project patterns
    axios.defaults.headers.common['Accept-Language'] = lang
    axiosClient.defaults.headers.common['Accept-Language'] = lang
    setMessages(menuMessages[locale])
  }, [locale])

  // ** Hàm chuyển đổi ngôn ngữ
  const switchLanguage = lang => {
    const newPath = lang === 'en' ? '/' : '/vi';
    window.location.assign(newPath);
  }

  return (
    <Context.Provider value={{ locale, switchLanguage }}>
      <IntlProvider key={locale} locale={locale === 'vn' ? 'vi' : locale} messages={messages} defaultLocale="en">
        {children}
      </IntlProvider>
    </Context.Provider>
  )
}

export { IntlProviderWrapper, Context as IntlContext }

